import React, { useContext, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ChatAppContext from "../../Chat";

/**
 * When navigating from support status (or elsewhere) with
 * `state={{ openChatId }}` or `?chat_id=`, select that thread once members load.
 */
const ChatOpenFromTicketState = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { members, memberLoading, changeChat } = useContext(ChatAppContext) || {};
  const openedForKey = useRef(null);

  useEffect(() => {
    openedForKey.current = null;
  }, [location.key]);

  useEffect(() => {
    if (memberLoading) return;
    const fromState = location.state?.openChatId;
    const fromQuery = new URLSearchParams(location.search || "").get("chat_id");
    const raw = fromState != null && fromState !== "" ? fromState : fromQuery;
    if (raw == null || raw === "") return;

    const id = Number(raw);
    if (!Number.isFinite(id) || id < 1) return;

    const key = `${location.key || "default"}-${id}`;
    if (openedForKey.current === key) return;

    const m = (members || []).find((x) => Number(x.chat_id) === id);
    if (m) {
      changeChat({ ...m, unread_msg_count: 0 });
      openedForKey.current = key;
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, members, memberLoading, changeChat, navigate]);

  return null;
};

export default ChatOpenFromTicketState;
